// Helpers for the per-day revenue aggregate (/api/revenue → chart/revenue).
//
// Each day row is { date:'YYYY-MM-DD', total, clinic } where `total` is the
// full treatment price (clinic + doctor) and `clinic` is the clinic's share.

/** Index revenue days by date → { total, clinic }. */
export function buildByDay(days) {
  const m = new Map()
  for (const d of days || []) {
    if (!d?.date) continue
    const cur = m.get(d.date) || { total: 0, clinic: 0 }
    cur.total  += Number(d.total)  || 0
    cur.clinic += Number(d.clinic) || 0
    m.set(d.date, cur)
  }
  return m
}

/** Sum { total, clinic } over an inclusive date-string range. */
export function sumRange(byDay, start, end) {
  let total = 0, clinic = 0
  if (!byDay) return { total, clinic }
  for (const [date, v] of byDay) {
    if (date >= start && date <= end) { total += v.total; clinic += v.clinic }
  }
  return { total, clinic }
}
